import { useSelector } from "react-redux";
import { CardBox } from "../../../../../component/basic/surfaces/box/CardBox";
import { CenterBox } from "../../../../../component/basic/surfaces/box/CenterBox";
import { selectLogin } from "../../../../../store/user/selector";
import { Banner } from "./Banner";
import { Rank } from "./rank/Rank";

export function Mid() {
    const login = useSelector(selectLogin);

    return (
        <CardBox sx={{ display: "flex", m: "10px" }}>
            {/* 左 */}
            <Banner />
            {/* 右 */}
            {login ? <Rank /> : <CenterBox sx={{ width: "50%" }}>登录后查看榜单</CenterBox>}
        </CardBox>
    );
}
